import * as React from 'react';
import {FC, useState} from 'react';
import {Card, CardContent, CardHeader, CardMedia, Chip, IconButton, Stack,} from '@mui/material';
import {Delete} from '@mui/icons-material';
import type {ShortWineDto} from '../../types/wine';

export const WineCard: FC<{
  w: ShortWineDto;
  onRemove?: () => void;
}> = ({w, onRemove}) => {

  const [imgSrc, setImgSrc] = useState<string | undefined>(w.imageUrl ?? '/wine-placeholder.jpg');

  const handleError = () => {
    if (imgSrc !== '/wine-placeholder.jpg') {
      setImgSrc('/wine-placeholder.jpg');
    }
  };

  return (
    <Card variant="outlined" sx={{height: '100%', position: 'relative'}}>
      <CardMedia
        component="img"
        height="200"
        image={imgSrc}
        alt={w.name}
        sx={{objectFit: 'contain', p: 1, background: '#fafafa'}}
        onError={handleError}
      />
      <CardHeader title={w.name} subheader={w.producer ?? ''} sx={{pb: 0}}/>
      <CardContent sx={{pt: 1}}>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {w.vintage && <Chip size="small" label={w.vintage}/>}
          {w.type && <Chip size="small" label={w.type}/>}
          {w.region && <Chip size="small" label={w.region}/>}
          {w.country && <Chip size="small" label={w.country}/>}
        </Stack>
      </CardContent>

      {!!onRemove && (
        <IconButton
          aria-label="remove"
          color="error"
          onClick={onRemove}
          sx={{position: 'absolute', top: 8, right: 8, bgcolor: 'white'}}
        >
          <Delete/>
        </IconButton>
      )}
    </Card>
  )
};
